import { computed, ref } from 'vue'
import { Nullable } from 'frontcore/presentation/types'

interface Props {
  disabled?: boolean
  error?: string
  value?: Nullable<string | number>
  nullable?: boolean
}

const useInputState = (props: Props) => {
  const isFocused = ref(false)
 
  const state = computed(() => {
    if (props.disabled) { return 'disabled'}
    else if (props.error) { return 'error'}
    else if (isFocused.value) { return 'focus'}
    return 'default'
  })
  const stateStyleClass = computed(() => `input-text__state-${state.value}`)

  return {
    stateStyleClass,
  }
}

export default useInputState
